export const ROLES_AVAILABLE = [
    'Student', 
    'Production', 
    'Shipping', 
    'Manager', 
    'Admin', 
    'Return',
    'Return Line', 
    '3pl',
    'Shipping CM',
    'Production CM',
    'Manager CM',
    'Reporting',
    'Migration Cetal',
    'Shipping MSE'
];